// Globals and Element Declarations
let productData = {};
const summaryWrapper = document.querySelector(
	".product__subscription-review--summary"
);
const sellingPlanInput = document?.querySelector('input[name="selling_plan"]');
const subscriptionOverlay = document?.querySelector(
	".product__subscription-loader"
);
const url = new URL(window.location.href);
const subscriptionPlanContainer = document
	.getElementById("subscription-variants")
	.querySelector(".product-variant__container");
const subscriptionFrequencyContainer = document
	.getElementById("subscription-frequencies")
	.querySelector(".product-variant__container");
const prepaidDurationWrapper = document.getElementById(
	"subscription-prepaid-durations"
);
const prepaidDurationList = document.getElementById(
	"subscription-prepaid-durations__list"
);
const sellingPlanFormInput = document.querySelector(
	'.product-form input[name="selling_plan"]'
);
let subscriptionTypeList = "";
let prepaidDurationTypeList = "";
let coffeeTypeList = "";

let hasPrepaid = "";

//Custom Functions
const hasPrepaidSellingGroup = () => {
	productData?.sellingPlanGroups?.forEach(({ name }) => {
		if (name === "Preapaid") {
			return true;
		}
	});
	return false;
};

const capitalizeFirstLetter = (string) => {
	return string.charAt(0).toUpperCase() + string.slice(1);
};

const initCoffeeTypeEventListeners = () => {
	Array.from(
		document.querySelectorAll('input[type="radio"][name="coffee_type"]')
	)?.map((radio) => {
		radio?.addEventListener("click", (e) => {
			coffeeTypeList.listContainer
				.querySelector(".product-variant__container")
				.classList.add("filtering");
			const coffee_type = e.target.getAttribute("value");
			coffeeTypeList.filter((item) => {
				if (item.elm.getAttribute("data-coffee-type") === coffee_type) {
					return item;
				}
			});

			coffeeTypeList.listContainer
				.querySelector(".product-variant__container")
				.classList.remove("filtering");

			coffeeTypeList.listContainer
				.querySelector(".product-variant__container")
				.classList.add("filtered");

			const firstSelection = document.querySelector(
				'#subscription-coffee-type__list input[type="radio"]'
			);
			firstSelection.checked = true;
		});
	});
};

/**
 * Initialises a list for the coffee types - e.g. Blend, Decaf, Single Origin etc.
 */
const initCoffeeTypeList = () => {
	coffeeTypeList = new List("subscription-coffee-type__list", {
		valueNames: [
			{
				attr: "data-coffee-type",
				name: "coffee-type",
			},
		],
	});

	const selectedType = document.querySelector(
		'input[type="radio"][name="coffee_type"]:checked'
	);

	if (selectedType) {
		coffeeTypeList.filter((item) => {
			if (
				item.elm.getAttribute("data-coffee-type") ===
				selectedType.getAttribute("value")
			) {
				return item;
			}
		});
	}
};

/**
 * Initialise the Duration Type List - for the Prepaid Variants
 */
const initPrePaidDurationTypeList = () => {
	//Check that the parent element exists in the DOM - this is conditionally rendered by Liquid depending on if there is a prepaid plan or not.
	if (document.getElementById("subscription-prepaid-durations__list")) {
		prepaidDurationTypeList = new List("subscription-prepaid-durations__list", {
			valueNames: [
				{
					attr: "data-duration",
					name: "duration",
				},
			],
		});

		prepaidDurationTypeList?.on("filterComplete", () => {
			const firstVariant = document.querySelector(
				'#subscription-prepaid-durations input[type="radio"]'
			);
			firstVariant.checked = true;
			sellingPlanFormInput.value = firstVariant?.value;
		});
	}
};

/**
 * Initialise the Subscription Type List for the Prepaid or Ongoing Variants
 */
const initList = () => {
	subscriptionTypeList = new List("subscription-frequencies", {
		valueNames: [
			"ongoing-frequencies",
			"prepaid-frequencies",
			{
				attr: "data-parent",
				name: "parent",
			},
		],
	});

	subscriptionTypeList.on("filterComplete", () => {
		const firstVariant = document.querySelector(
			'#subscription-frequencies input[type="radio"]'
		);
		firstVariant.checked = true;
		sellingPlanFormInput.value = firstVariant?.value;
		if (firstVariant.getAttribute("data-filter") === "prepaid") {
			prepaidDurationTypeList.filter((item) => {
				const selectedPrepaidFrequency = document.querySelector(
					'.prepaid-frequencies input[type="radio"]:checked'
				);
				if (
					item?.elm.getAttribute("data-duration") ==
					selectedPrepaidFrequency?.value
				) {
					return item;
				}
			});
		}
	});

	const subscriptionType = document.querySelector(
		'#subscription-variants .product-variant__item:first-of-type input[type="radio"]'
	);
	subscriptionTypeList.filter((item) => {
		if (item.values()?.parent === subscriptionType.value) {
			return true;
		}
	});
};

const renderSubscriptionPlans = () => {
	productData?.selling_plan_groups?.forEach(({ id, name }, index) => {
		let variant = document.createElement("div");
		variant.classList.add("product-variant__item");
		let input = document.createElement("input");
		let label = document.createElement("label");
		input.setAttribute("type", "radio");
		input.setAttribute("value", id);
		input.checked = index === 0;
		input.setAttribute("name", "selling_plan_group");
		input.setAttribute("data-target", name.toLowerCase());
		label.addEventListener("click", (e) => {
			prepaidDurationWrapper.classList.toggle(
				"active",
				e.target.previousSibling.getAttribute("data-target").includes("prepaid")
			);
			e.target.previousSibling.checked = true;
			subscriptionTypeList.filter((item) => {
				if (item?.values()?.parent == e?.target?.previousSibling.value) {
					return item;
				}
			});
		});
		label.appendChild(document.createTextNode(name));
		label.classList.add("product-variant__label");
		variant.appendChild(input);
		variant.appendChild(label);
		subscriptionPlanContainer.appendChild(variant);
	});
};

const renderSubscriptionTypes = () => {
	let planFrequencies = {
		ongoing: [],
		prepaid: {},
	};

	productData?.selling_plan_groups?.forEach(
		({ name, selling_plans }, index) => {
			const isPrepaid = name?.includes("Prepaid");
			let key = "";
			selling_plans?.forEach(({ id, name }) => {
				if (isPrepaid) {
					key = name.substring(0, name.indexOf(" ")).toLowerCase();
					const frequencyString = name?.match(/\d.*/gi)
						? name?.match(/\d.*/gi)
						: [""];

					if (!planFrequencies.prepaid[key]) {
						planFrequencies.prepaid[key] = [];
						planFrequencies.prepaid[key].push({
							id: id,
							frequency: frequencyString[0],
							parent: productData?.selling_plan_groups[index]?.id,
						});
					} else {
						planFrequencies.prepaid[key].push({
							id: id,
							frequency: frequencyString[0],
							parent: productData?.selling_plan_groups[index]?.id,
						});
					}
				} else {
					planFrequencies.ongoing.push({
						id: id,
						name: name,
						parent: productData?.selling_plan_groups[index]?.id,
					});
				}
			});
		}
	);

	if (planFrequencies?.ongoing) {
		let ongoingFrequencies = document.createElement("div");
		ongoingFrequencies.classList?.add("ongoing-frequencies");
		planFrequencies?.ongoing?.forEach(({ id, name, parent }, index) => {
			let variant = document.createElement("div");
			variant.classList.add("product-variant__item");
			variant.classList.add("parent");
			variant.setAttribute("data-parent", parent);
			let input = document.createElement("input");
			let label = document.createElement("label");
			input.setAttribute("type", "radio");
			input.setAttribute("value", id);
			input.setAttribute("name", "selling_plan_frequency");
			input.setAttribute("data-filter", "ongoing");
			input.checked = index === 0;
			label.addEventListener("click", (e) => {
				e.target.previousSibling.checked = true;
				sellingPlanFormInput.setAttribute(
					"value",
					e.target.previousSibling.value
				);
			});
			label.appendChild(document.createTextNode(name));
			label.classList.add("product-variant__label");
			variant.appendChild(input);
			variant.appendChild(label);
			ongoingFrequencies.appendChild(variant);
		});
		subscriptionFrequencyContainer.appendChild(ongoingFrequencies);
	}

	if (planFrequencies?.prepaid) {
		let prepaidFrequencies = document.createElement("div");
		prepaidFrequencies.classList?.add("prepaid-frequencies");
		prepaidFrequencies?.setAttribute("id", "prepaid_frequencies");
		let durationListWrapper = document.createElement("div");
		durationListWrapper.classList.add("list");
		durationListWrapper.classList.add("product-variant__container");
		Object.keys(planFrequencies?.prepaid).forEach((key) => {
			let variant = document.createElement("div");
			variant.classList.add("product-variant__item");
			variant.setAttribute(
				"data-parent",
				planFrequencies?.prepaid[key]?.[0]?.parent
			);
			variant.classList.add("parent");
			let input = document.createElement("input");
			let label = document.createElement("label");
			input.setAttribute("type", "radio");
			input.setAttribute("value", key);
			input.setAttribute("name", "selling_plan_frequency");
			input.setAttribute("data-filter", "prepaid");
			label.addEventListener("click", (e) => {
				e.target.previousSibling.checked = true;
				prepaidDurationTypeList.filter((item) => {
					if (
						item?.elm.getAttribute("data-duration") ==
						e.target.previousSibling.value
					) {
						return true;
					}
				});
			});
			label.classList.add("product-variant__label");
			label.appendChild(document.createTextNode(capitalizeFirstLetter(key)));
			variant.appendChild(input);
			variant.appendChild(label);
			prepaidFrequencies.appendChild(variant);

			if (planFrequencies?.prepaid[key]) {
				planFrequencies?.prepaid[key].forEach(({ id, frequency }, index) => {
					let durationVariant = document.createElement("div");
					durationVariant.classList.add("duration");
					durationVariant.classList.add("product-variant__item");
					durationVariant.setAttribute("data-duration", key);
					let input = document.createElement("input");
					let label = document.createElement("label");
					input.setAttribute("type", "radio");
					input.setAttribute("value", id);
					input.setAttribute("name", "selling_plan_type");
					input.checked = index === 0;
					label.classList.add("product-variant__label");
					label.appendChild(document.createTextNode(frequency));
					label.addEventListener("click", (e) => {
						e.target.previousSibling.checked = true;
						sellingPlanFormInput.setAttribute(
							"value",
							e.target.previousSibling.value
						);
					});
					durationVariant.appendChild(input);
					durationVariant.appendChild(label);
					durationListWrapper.appendChild(durationVariant);
				});
			}
		});

		prepaidDurationList?.appendChild(durationListWrapper);
		subscriptionFrequencyContainer.appendChild(prepaidFrequencies);
	}
};

fetch(`${url.pathname}.js`)
	.then((res) => res.json())
	.then((data) => {
		productData = data;
		renderSubscriptionPlans();
		renderSubscriptionTypes();
		initList();
		initPrePaidDurationTypeList();
		initCoffeeTypeEventListeners();
		initCoffeeTypeList();
	})
	.finally(() => {
		subscriptionOverlay.classList.remove("active");
	});
